/* eslint-disable react-hooks/exhaustive-deps */
import { AgGridReact } from 'ag-grid-react';
import Axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import React, { useContext, useMemo, useState, useEffect } from "react";
import "../../CSS/general.css";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { Modal, Button } from "react-bootstrap";
import { AppContext } from "./AppContext";
import LoaderGif from "../../images/365 loading.gif";
import { toast } from 'react-toastify';

const AadJobList = (props) => {
    const [gridApi, setGridApi] = useState(null);
    const [appOrg, setAppOrg] = useContext(AppContext);
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const retainSelection =true;


    const rowHeight = 25;
    const headerHeight = 30;
    const getRowStyle = params => {
        return { fontSize: "Small" };
    };

    function onFirstDataRendered(params) {
        params.api.sizeColumnsToFit();
    }

    const showToast = (type, message) => {
        if (type === "success") {
            toast.success(message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
        else if (type === "error") {
            toast.error(message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
    };

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
    }), []);

    const onGridReady = (params) => {
        params.api.setGridOption("loading", true);
        setGridApi(params.api);
        ////params.api.setRowData(props.rowData);
        params.api.setGridOption('rowData', props.rowData);
        // getData(params.api);
        params.api.sizeColumnsToFit();
        params.api.setGridOption("loading", false);
    }

    const onRowClicked = (params) => {
        props.onJobSelect(params.data.jobID);
    }
    useEffect(() => {
        if (gridApi) {
            gridApi.setGridOption('rowData', props.rowData)
            if (selectedRowIds.length > 0 && retainSelection) {
                selectedRowIds.forEach((id) => {
                    const rowNode = gridApi && gridApi.getRowNode(id);
                    if (rowNode) {
                        rowNode.setSelected(true);
                    }
                });
            }
        }
            

    }, [props.rowData]);


    const ManageAadJob = async (action, jobID) => {
        const config = {
            headers: {
                Authorisation: `Bearer ` + props.token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let payload = {
            action: action,
            orgName: appOrg.tenantId,
            jobId: jobID.toString()
        };
        const data = await Axios.post(API_ROUTE + Routes.MANAGE_ENTRA_JOB(jobID.toString()), payload, config)
            .then((response) => {
                if (response.data === "Success") {

                }
            })
            .catch((reason) => {
                console.log((reason.message)); 
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        props.refresh();
        return data;
    }
    const editAADJobClick = async (data) => {
        //appContext.entraJob.name = data.name;
        //appContext.entraJob.description = data.description;
        setAppOrg((prev) => {
            return {
                ...prev,
                entraJob: {
                    name: data.name,
                    description: data.description,
                    //selectedItems: [],
                    selectedItems: [data.serviceGroupID],
                    schedule: data.scheduleID,
                    isEditJob: true,
                    jobID:data.jobID
                }
            }
        });
        props.handleAADJobClick('Edit', data.jobID)
    }
    const deleteNotificationModal = async (action, jobID,jobName) => {
        setDeleteJobName(jobName)
        setDeleteJobId(jobID)
        handleShow();
    }
    const deleteConfirmation = async () => {
        const config = {
            headers: {
                Authorisation: `Bearer ` + props.token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        await Axios.delete(API_ROUTE + Routes.DELETE_GUARDIAN_JOB(deleteJobId) , config)
            .then((response) => {
                props.refresh();
                if (response.data === "Success") {
                    showToast("success", deleteJobName + " Deleted successfully")
                }
                
            })
            .catch((reason) => {
                console.log((reason.message));
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        handleClose();
        props.refresh();

        setDeleteJobName("");
        setDeleteJobId(0);
        
    }
    const columnDefs = [
        {
            field: 'name', headerName: '', minWidth: 150, flex: 1, maxWidth: 170,
            cellRenderer: (params) => <div>
                {params.data.status === "Pending" ? (<button id={"AadButtonRunJob" + params.data.name} title="Run job now" className="me-1 a-icon" onClick={() => {
                    return;
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="18" height="18" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                            <path d="M3933 5015 c-193 -52 -357 -225 -393 -414 -48 -256 98 -508 348 -598 189 -69 399 -18 548 133 204 208 202 528 -5 735 -134 134 -327 190 -498 144z" />
                            <path d="M2175 4226 c-16 -7 -220 -194 -453 -415 -489 -466 -477 -450 -477 -601 0 -85 3 -100 27 -141 68 -116 192 -174 318 -148 30 6 74 22 97 35 24 14 168 158 344 344 l302 320 99 0 c55 0 98 -4 96 -8 -1 -5 -302 -342 -666 -750 l-664 -741 -456 -3 c-449 -3 -458 -4 -513 -26 -65 -26 -140 -87 -175 -144 -35 -54 -57 -151 -51 -215 12 -111 91 -228 187 -278 83 -42 132 -45 784 -45 573 0 624 1 653 18 17 9 171 167 343 350 171 183 315 332 319 330 4 -2 126 -126 269 -277 210 -219 261 -277 257 -295 -3 -11 -41 -255 -86 -541 -65 -416 -80 -534 -76 -587 16 -191 184 -332 375 -315 78 8 179 55 226 107 71 79 75 97 225 900 78 415 141 762 141 770 0 8 -171 186 -380 395 l-380 380 293 293 292 292 215 -216 c255 -255 275 -269 400 -269 73 0 92 4 135 27 36 19 169 146 466 445 389 390 418 422 438 476 27 73 27 131 0 204 -25 65 -94 145 -151 174 -87 44 -210 43 -288 -3 -19 -12 -150 -136 -292 -276 -200 -199 -262 -254 -282 -254 -29 0 -20 -9 -405 347 -300 277 -348 316 -410 337 -56 18 -1055 23 -1096 4z" />
                        </g>
                    </svg>

                </button>) :
                    (<button id={"AadButtonRunJob" + params.data.name} title="Run job now" className="me-1 a-icon" onClick={() => {
                        ManageAadJob("Run", params.data.jobID);

                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="18" height="18" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                                <path d="M3401 5104 c-82 -17 -190 -69 -266 -127 -101 -77 -169 -170 -218 -302 -27 -72 -30 -92 -31 -205 -1 -69 2 -139 6 -157 l7 -32 -612 -3 -612 -3 -69 -33 c-83 -39 -146 -88 -185 -145 -36 -53 -404 -720 -445 -807 -60 -128 -46 -305 33 -428 113 -175 326 -253 522 -192 155 47 210 110 389 435 l138 250 121 3 120 3 -361 -631 -361 -630 -521 0 c-566 0 -599 -3 -697 -57 -68 -37 -153 -125 -188 -194 -122 -245 -10 -537 246 -641 l58 -23 704 -3 c483 -2 721 1 758 8 78 17 169 66 227 125 29 29 85 108 129 183 43 73 80 132 83 132 7 0 334 -261 334 -266 0 -3 -70 -179 -155 -390 -168 -416 -181 -462 -164 -580 37 -264 307 -446 562 -379 116 30 217 101 275 192 49 78 480 1159 494 1241 20 121 -20 265 -102 364 -17 20 -154 134 -305 253 -151 119 -275 221 -275 226 0 9 194 346 225 392 11 15 21 3 88 -101 111 -172 186 -237 316 -276 73 -22 201 -20 268 2 28 10 237 121 464 248 454 251 489 277 548 395 148 297 -48 643 -379 666 -118 8 -175 -11 -413 -143 -114 -64 -210 -114 -212 -112 -2 2 -67 100 -144 218 l-140 215 59 16 c402 110 605 561 421 934 -69 138 -169 238 -307 306 -136 66 -288 85 -433 53z m293 -317 c77 -35 140 -98 179 -176 29 -60 32 -73 32 -161 -1 -82 -4 -102 -28 -150 -34 -71 -106 -143 -177 -178 -49 -24 -66 -27 -155 -27 -87 0 -107 3 -155 26 -70 33 -141 103 -177 177 -25 51 -28 68 -28 157 0 90 3 105 28 153 53 101 136 170 236 199 68 19 179 10 245 -20z m-576 -846 c26 -21 71 -52 100 -68 50 -29 63 -46 310 -424 285 -436 292 -444 377 -437 42 4 93 29 315 153 157 87 280 150 301 152 139 19 233 -150 143 -256 -15 -19 -175 -113 -422 -250 -372 -207 -401 -221 -448 -221 -81 0 -101 20 -260 263 -78 120 -152 229 -165 243 -46 49 -139 52 -196 6 -17 -13 -411 -671 -469 -783 -18 -36 -18 -102 1 -139 8 -16 149 -134 332 -278 175 -138 329 -260 342 -273 27 -26 51 -78 51 -114 0 -29 -433 -1116 -458 -1152 -22 -29 -90 -63 -128 -63 -48 1 -109 34 -134 75 -43 70 -40 82 153 561 188 470 197 499 159 557 -29 44 -609 495 -653 509 -50 14 -105 -1 -141 -39 -15 -16 -77 -113 -138 -218 -124 -210 -148 -241 -200 -256 -23 -6 -266 -9 -702 -7 -655 3 -667 3 -694 24 -53 39 -69 71 -69 134 0 63 16 95 69 134 27 21 41 21 624 26 455 4 602 8 619 18 12 7 33 27 46 45 13 17 225 384 471 815 308 537 449 794 453 820 6 51 -30 119 -77 144 -32 16 -65 18 -363 18 -376 0 -377 0 -425 -79 -16 -25 -93 -165 -173 -310 -161 -294 -176 -312 -262 -318 -96 -7 -167 60 -167 157 0 41 23 88 206 420 113 206 213 384 222 394 10 10 31 27 47 37 28 18 65 19 693 19 l663 0 47 -39z" />
                            </g>
                        </svg>
                    </button>) }

                {!params.data.active ? (<button id={"AadButtonStopJob" + params.data.name} title="Disable job" className="me-1 a-icon" onClick={() => {
                    return;
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="red" className="bi bi-pause-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                    </svg>
                </button>) : (
                        <button id={"AadButtonStopJob" + params.data.name} title="Disable job" className="me-1 a-icon" onClick={() => {
                        ManageAadJob("Stop", params.data.jobID);
                    }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-pause-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                            </svg>
                    </button>)
                    }

                {params.data.status === "Enable" ? (
                    <button id={"AadButtonEnableJob" + params.data.name} title="Enable job" className="me-1 a-icon" onClick={() => {
                        return;
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#1a5393" className="bi bi-play-circle-fill" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z" />
                        </svg>
                    </button>)
                    : (
                        <button id={"AadButtonEnableJob" + params.data.name} title="Enable job" className="me-1 a-icon" onClick={() => {
                            ManageAadJob("Enable", params.data.jobID);
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-play-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                            </svg>
                        </button>)
                    
                }
                <button className='a-icon' id={"ButtonEditJob" + params.data.name} title="Edit job" onClick={() => { editAADJobClick(params.data) }} style={{ marginRight: '.1rem' }}
                    
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                    </svg>
                </button>
                <button className='a-icon' id={"ButtonDeleteJob" + params.data.name} title="Delete job" onClick={() => {
                    deleteNotificationModal("Delete", params.data.jobID, params.data.name);
                }
                }>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                    </svg>
                </button>
            </div >
        },

        { field: 'name', headerName: 'Name', minWidth: 200, flex: 1 },
        { field: 'status', headerName: 'Status', minWidth: 100, maxWidth: 160, flex: 1 },
        { field: 'jobType', headerName: 'JobType', minWidth: 100, maxWidth: 160, flex: 1 },
        { field: 'description', headerName: 'Description', minWidth: 200, flex: 1 },
        {
            field: 'lastRun', headerName: 'Last Backup', minWidth: 160, flex: 1, valueFormatter: (params) => {
                // Check if nextRun has a valid date value
                if (params.value) {
                    const date = new Date(params.value);
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                    const year = date.getFullYear();
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');

                    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                }
                return ''; // Return empty string if no valid date
            },
            // Ensure proper sorting by datetime, not string
            comparator: (date1, date2) => {
                const d1 = new Date(date1);
                const d2 = new Date(date2);
                return d1 - d2;
            }
        },
        {
            field: 'nextRun', headerName: 'Next Run', minWidth: 160, flex: 1, valueFormatter: (params) => {
                // Check if nextRun has a valid date value
                if (!params.data.active) {
                    return "Disabled";
                }
                if (params.value) {
                    const date = new Date(params.value);
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                    const year = date.getFullYear();
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');

                    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                }
                return ''; // Return empty string if no valid date
            },
            // Ensure proper sorting by datetime, not string
            comparator: (date1, date2) => {
                const d1 = new Date(date1);
                const d2 = new Date(date2);
                return d1 - d2;
            }
        }
    ];
    const [show, setShow] = useState(false);
    const [deleteJobName, setDeleteJobName] = useState("");
    const [deleteJobId, setDeleteJobId] = useState(0);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (

        <div className="card" id="joblist">
            <div className="card-body p-0">
                <div id="ContentPlaceHolder1_UpdatePanelJobList">
                    <div id="ContentPlaceHolder1_Panel3" style={{ height: "180px", width: "100%" }}>
                        {props.isAzureAvailable ? <div className="ag-theme-alpine p-1 pt-0" style={{  width: "100%", height: "180px", borderCollapse: "collapse" }} >

                            <AgGridReact style={{ width: "80%" }}
                                onFirstDataRendered={onFirstDataRendered}
                                getRowStyle={getRowStyle}
                                onRowClicked={onRowClicked}
                                onGridReady={onGridReady}
                                defaultColDef={defaultColDef}
                                rowSelection={{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }}
                                rowBuffer={500}
                                columnDefs={columnDefs}
                                headerHeight={headerHeight}
                                enableCellTextSelection="true"
                                ensureDomOrder="true"
                                onSelectionChanged={(e) => {
                                    const selectedNodes = e.api.getSelectedNodes();
                                    if (selectedNodes.length === 0) return;

                                    const selectedRowIds = selectedNodes
                                        .map((n) => n.id);

                                    setSelectedRowIds(selectedRowIds);
                                }}
                                overlayLoadingTemplate={
                                    `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                                overlayNoRowsTemplate={
                                    '<span className="ag-overlay-loading-center">No records to show</span>'
                                }
                                suppressScrollOnNewData={retainSelection}
                                rowHeight={rowHeight}
                            >
                            </AgGridReact>
                            :
                            <div>Loading...</div>
                        </div>
                            : <div style={{ height: '100%' }}><span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height:'100%' }}>Not Available in your selected package</span></div>}
                        
                    </div>
                </div>
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure want to delete <b>{deleteJobName}</b>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={deleteConfirmation}>
                        Yes
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default AadJobList;